import React, { Component } from 'react';
import Countdown from 'react-countdown-now';
import Blockies from 'react-blockies';
import { Icon, Tooltip } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { inject, observer } from 'mobx-react';
import AddJudgeModal from '../modals/AddJudgeModal';
import { FaGavel } from 'react-icons/fa';
import CreatorName from './CreatorName';
import { ethMultiplier, zeroAddress } from "../../constants";


@observer(["UserStore"])
class CustomBetsCardTaken extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toolTipMessage: 'Click to Copy',
        };

    }
    render() {
        const { UserStore } = this.props;
        let timeNow = new Date().getTime() / 1000;
        let cardClassName = ""
        let openClosedIcon = ""

        if (this.props.status !== "cancelled") {
            cardClassName = "custom-bets-page-cards-open";
            openClosedIcon = <div className="custom-bets-page-cards-status-open-expired-icon">
                <div className="open-icon"></div>
                <span>Open</span>
            </div>
        } else {
            cardClassName = "custom-bets-page-cards-closed";
            openClosedIcon = <div className="custom-bets-page-cards-status-open-expired-icon">
                <div className="closed-icon"></div>
                <span style={{ color: '#f73527' }}>Closed</span>
            </div>
        }

        let userVsOponnentGrid = "";
        let takenMadeByYou = "";
        let addJudgeBtn = "";

        if (this.props.makerTaker == "maker") {
            takenMadeByYou = "MADE BY YOU";
            userVsOponnentGrid = <div className="custom-bets-page-rows-teams">
                <div className="custom-bets-page-rows-teams-teamone">
                    <span><Blockies seed={this.props.wager.makerETHAddress} /></span>
                    {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                    <div>YOU</div>
                    <div>YOUR BET: <span style={{ color: "rgba(255, 230, 0, 0.8)" }}>{(this.props.wager.value / ethMultiplier).toFixed(4)}</span></div>
                </div>

                <div className="custom-bets-page-rows-teams-vs">
                    <div style={{ marginTop: '-10px' }}>
                        VS
                    </div>
                </div>
                <div className="custom-bets-page-rows-teams-teamtwo">
                    {this.props.wager.taker != "" ?
                        <span><Blockies seed={this.props.wager.takerETHAddress} /></span>
                        :
                        <span><Icon type="hourglass" /></span>}
                    <div>{this.props.wager.taker != "" ? <CreatorName userId={this.props.wager.taker} /> : "WAITING FOR TAKER"}</div>
                    <div>OPPONENT'S BET: <span style={{ color: "rgba(255, 230, 0, 0.8)" }}>{this.props.wager.odds > 99 ?
                        (((this.props.wager.value) / (this.props.wager.odds / 100)) / ethMultiplier).toFixed(4)
                        : ((((this.props.wager.value) * Math.floor(100 / this.props.wager.odds))) / ethMultiplier).toFixed(4)
                    }</span></div>
                </div>
            </div>
            if (this.props.wager.judge == "0x0000000000000000000000000000000000000000") {
                addJudgeBtn = <AddJudgeModal
                    wagerId={this.props.wager._id}
                    wagerBytes32Id={this.props.wager.bytes32Id}
                />
            }
        } else {
            takenMadeByYou = "TAKEN BY YOU";
            userVsOponnentGrid = <div className="custom-bets-page-rows-teams">
                <div className="custom-bets-page-rows-teams-teamone">
                    {this.props.wager.taker != "" ? <span><Blockies seed={this.props.wager.makerETHAddress} /></span>
                        : <span><Icon type="hourglass" /></span>}
                    <div>{this.props.wager.taker != "" ? <CreatorName userId={this.props.wager.maker} /> : "WAITING FOR TAKER"}</div>
                    <div>OPPONENT'S BET: <span style={{ color: "rgba(255, 230, 0, 0.8)" }}>{(this.props.wager.value / ethMultiplier).toFixed(4)}</span></div>
                </div>
                <div className="custom-bets-page-rows-teams-vs">
                    <div style={{ marginTop: '-10px' }}>VS</div>
                </div>
                <div className="custom-bets-page-rows-teams-teamtwo">
                    <span><Blockies seed={this.props.wager.takerETHAddress} /></span>
                    {/* //src="http://www.countryflags.io/CA/flat/64.png" width="30px" /></span> */}
                    <div>YOU</div>
                    <div>YOUR BET: <span style={{ color: "rgba(255, 230, 0, 0.8)" }}>{this.props.wager.odds > 99 ?
                        (((this.props.wager.value) / (this.props.wager.odds / 100)) / ethMultiplier).toFixed(4)
                        : (((this.props.wager.value) * Math.floor(100 / this.props.wager.odds)) / ethMultiplier).toFixed(4)
                    }</span></div>
                </div>
            </div>
        }
        return (
            <div className="custom-bets-page-cards">
                <div className={cardClassName}>
                    {userVsOponnentGrid}
                    <div className="custom-bets-page-cards-event-info">
                        <div>{takenMadeByYou}</div>
                    </div>
                    <div className="custom-bets-page-cards-event-info" style={{ cursor: 'pointer', padding: "3px" }}>
                        <CopyToClipboard text={this.props.wager._id} onCopy={() => this.setState({ toolTipMessage: 'Copied!' })}>
                            <Tooltip placement="bottom" title={this.state.toolTipMessage}>
                                <span style={{ borderStyle: "solid", borderRadius: "4px", borderColor: "#3296f7", borderWidth: "1px", padding: "3px" }}>BET ID : {this.props.wager._id}</span>
                            </Tooltip>
                        </CopyToClipboard>
                    </div>
                    {/* <div className="custom-bets-page-cards-event-info">
                        {this.props.status === 'no-votes-pre-end-time-pre-reporting-end-time' ? "Waiting for event to finish" :
                            this.props.status === 'no-votes-post-end-time-post-reporting-end-time' ? "Reporting Period Over" :
                                this.props.status === 'maker-taker-voted-post-end-time' ? "Both players have voted on the result" :
                                    this.props.status === 'only-taker-voted-post-end-time' ? "One player has voted on the result" :
                                        this.props.status === 'only-maker-voted-post-end-time' ? "One player has voted on the result" :
                                            this.props.status === 'only-maker-voted-post-reporting-end-time' ? "Bet maker has voted on the result" :
                                                this.props.status === 'only-taker-voted-post-reporting-end-time' ? "Bet taker has voted on the result" : this.props.status}
                    </div> */}
                    {this.props.wager.taker === "" && this.props.wager.endTime > Date.now() / 1000 ?
                        <div className="custom-bets-page-cards-event-info">
                            {addJudgeBtn}
                        </div> : null}
                    {this.props.wager.judge !== zeroAddress ? <div className="custom-bets-page-cards-event-info"><span style={{ fontSize: "10pt", color: "rgba(255, 230, 0, 0.8)" }}><FaGavel />  JUDGE</span>
                        <span style={{ fontSize: "10pt", borderRadius: "3px", borderStyle: "solid", borderRadius: "4px", borderWidth: "1px", borderColor: "rgba(255, 230, 0, 0.8)" }}> {this.props.wager.judge}</span></div> : null}
                    <div className="custom-bets-page-cards-stage" style={{ gridTemplateColumns: this.props.status == "cancelled" ? '1fr' : '1fr 1fr' }}>
                        {this.props.stage}
                    </div>
                    <div className="custom-bets-page-cards-bet-options-pick-title">
                        <span>OUTCOMES</span>
                    </div>


                    <div className="custom-bets-page-cards-bet-options">
                        <button className="custom-bets-page-cards-options-teamone">
                            <span className="custom-bets-page-cards-bet-options-title">MAKER</span>
                            <div className="custom-bets-page-cards-bets-amount">{this.props.wager.outcomeOne}</div>
                        </button>
                        <button className="custom-bets-page-cards-options-teamtwo">
                            <span className="custom-bets-page-cards-bet-options-title">TAKER</span>
                            <div className="custom-bets-page-cards-bets-amount">{this.props.wager.outcomeTwo}</div>
                        </button>
                    </div>
                    <div className="custom-bets-page-cards-status">
                        <div className="custom-bets-page-cards-status-open-expired">
                            {openClosedIcon}
                            <div className="custom-bets-page-cards-status-time-remaining">
                                {this.props.stage == ""} <Countdown zeroPadLength={2} date={new Date(this.props.wager.reportingEndTime).getTime() * 1000}>
                                    <span>ENDED, NO TIME</span>
                                </Countdown>
                                <span style={{ marginLeft: '5px' }}>UNTIL REPORTING END TIME</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CustomBetsCardTaken;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/CustomBetsCard.js